import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ArmSideNavModule} from '../../components/arm-side-nav/arm-side-nav.module';
import {NetworkServicesComponent} from './network-services.component';
import { SyslogComponent } from './syslog/syslog.component';
import { NtpComponent } from './ntp/ntp.component';
import { QosComponent } from './qos/qos.component';
import { CdrComponent } from './cdr/cdr.component';
import {LayoutModule} from '../../components/layout/layout.module';
import {ActionBarModule} from '../../components/action-bar/action-bar.module';
import {ArmTableModule} from '../../components/arm-table/arm-table.module';
import { SyslogDialogComponent } from './syslog/syslog-dialog/syslog-dialog.component';
import {MaterialModule} from '../../material.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { NtpDialogComponent } from './ntp/ntp-dialog/ntp-dialog.component';
import {ArmFormModule} from '../../components/arm-form/arm-form.module';
import {ArmFormTitleModule} from '../../components/arm-form/arm-form-title/arm-form-title.module';
import { WebSocketComponent } from './web-socket/web-socket.component';



@NgModule({
  declarations: [NetworkServicesComponent, SyslogComponent, NtpComponent, QosComponent, CdrComponent, SyslogDialogComponent, NtpDialogComponent, WebSocketComponent],
  imports: [
    CommonModule,
    ArmSideNavModule,
    LayoutModule,
    ActionBarModule,
    ArmTableModule,
    MaterialModule,
    FormsModule,
    ArmFormModule,
    ArmFormTitleModule,
    ReactiveFormsModule
  ]
})
export class NetworkServicesModule { }
